import { render, staticRenderFns } from "./StudentProgressPanel.vue?vue&type=template&id=083b78cd&scoped=true&lang=pug&"
import script from "./StudentProgressPanel.vue?vue&type=script&lang=ts&"
export * from "./StudentProgressPanel.vue?vue&type=script&lang=ts&"
import style0 from "./StudentProgressPanel.vue?vue&type=style&index=0&id=083b78cd&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083b78cd",
  null
  
)

export default component.exports